import consoleLogger from '../../../../modules/console-logger'

const cmpWallShow = () => {
  const [consoleLog] = consoleLogger('CMP')

  tp.push([
    'init',
    function () {
      let offerId = 'OFAVNZIEEW2Z'
      let templateId = 'OTPWRVC0F1H8'

      if (tp && tp.aid === 'WGs1UJpXpu') {
        offerId = 'OFJC452N2741'
        templateId = 'OTXR6XM9GG1W'
      }

      consoleLog('WALL offerId', offerId)
      consoleLog('WALL templateId', templateId)

      tp.offer.show({
        offerId: offerId,
        templateId: templateId,
        displayMode: 'modal',

        loginRequired: function () {
          tp.push([
            'init',
            function () {
              tp.pianoId.show({
                disableSignUp: false,
                displayMode: 'modal',
                screen: 'login',
                showCloseButton: false,

                loggedIn: function () {
                  tp.experience.execute()
                },

                loggedOut: function () {},
              })
            },
          ])
        },

        showCloseButton: true,

        close: function () {},

        complete: function () {
          tp.experience.execute()
        },

        customEvent: function () {},
      })
    },
  ])
}

export default cmpWallShow
